import { render, staticRenderFns } from "./KoreanCartNew.vue?vue&type=template&id=545b79fe&scoped=true"
import script from "./KoreanCartNew.vue?vue&type=script&lang=js"
export * from "./KoreanCartNew.vue?vue&type=script&lang=js"
import style0 from "./KoreanCartNew.vue?vue&type=style&index=0&id=545b79fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b79fe",
  null
  
)

export default component.exports